export enum AbsenceLimitType {
  Vacation = 1,
  OnDemand = 2,
  ChildCare = 3,
  ChildHoursCare = 4,
  Disability = 5,
  JobSearchLeave= 6,
  UnpaidCareLeave=7,
  ForceMajeureLeave=8,
  ForceMajeureHourlyLeave=9,
  DayOffApplication=10,
}
